import React, { createContext, useContext, useState } from "react";
import Calculations from "../types/Calculations";

interface CalculationsContextValue {
  calculations: Calculations;
  setCalculations: (updatedProperties: Partial<Calculations>) => void;
  updateCalculations: (updatedProperties: Partial<Calculations>) => void;
}

export const CalculationsContext =
  createContext<CalculationsContextValue | null>(null);

export const useCalculations = (): CalculationsContextValue => {
  const context = useContext(CalculationsContext);
  if (!context) {
    throw new Error(
      "useCalculations must be used within a CalculationsContextProvider"
    );
  }
  return context;
};

interface CalculationsContextProviderProps {
  initialCalculations: Calculations;
  children: React.ReactNode;
}

export const CalculationsContextProvider: React.FC<
  CalculationsContextProviderProps
> = ({ initialCalculations, children }) => {
  const [calculations, setCalculations] = useState(initialCalculations);

  const updateCalculations = (updatedProperties: Partial<Calculations>) => {
    setCalculations((prevCalculations) => ({
      ...prevCalculations,
      ...updatedProperties,
    }));
  };

  return (
    <CalculationsContext.Provider
      value={{ calculations, setCalculations: updateCalculations }}
    >
      {children}
    </CalculationsContext.Provider>
  );
};
